import script from "./VideoUploaderConfirmButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoUploaderConfirmButton.vue?vue&type=script&setup=true&lang=ts"

import "./VideoUploaderConfirmButton.vue?vue&type=style&index=0&id=7723959b&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7723959b"]])

export default __exports__